import Api from '../../../shared/Api';

class SharedApi {
    static getCompareData(planOrderId: number): Promise<any> {
        return new Api().get(`/views/shared/planorder/${planOrderId}/compare`);
    }
}

export default SharedApi;
